module.exports = __webpack_public_path__ + "static/media/instagram.0f4e9ef5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/instagram.svg
// module id = 52
// module chunks = 0